<template lang="pug">
  //- TODO - cms related options (auto: api recommendations, manual: 3 products)
  //- intersection-observer.related-products.pt-1000.-mt-1000.pointer-events-none(:threshold="0.1", @visible="get")
  ul.mt-60.md-mt-100.sm-flex.px-40.sm-px-12.lg-px-50.justify-center(v-if="docs.length")
    li.mb-100.sm-mb-0.sm-w-1x3.sm-px-12.lg-px-30(v-for="doc in docsSorted")
      product-thumb(:doc="doc")
</template>

<script>
import ProductThumb from './ProductThumb'
import { optimImgSize } from '@/utils'
export default {
  name: 'RelatedProducts',
  props: {
    handles: { type: Array, default: () => ([]) }
  },
  data () {
    return {
      docs: []
    }
  },
  computed: {
    docsSorted () {
      return this.handles.map(hndl => this.docs.find(doc => doc.handle === hndl))
    }
  },
  methods: {
    getDocs () {
      let w = window.innerWidth
      w = w > 600 ? w / 3 : w
      this.handles.forEach(hndl => {
        console.log(hndl)
        this.$store.dispatch('shop/getProduct', { handle: hndl, imgMaxW: optimImgSize(w) })
          .then(doc => { this.docs.push(doc) })
          .catch(err => console.error(err))
      })
    }
  },
  created () {
    this.getDocs()
  },
  components: { ProductThumb }
}
</script>

<style>
</style>
